// Paleta e dados da empresa centralizados
export const BRAND = {
  main: "#036D3D",
  dark: "#004C2A",
  glass: "rgba(1,43,24,.58)",
  line: "rgba(3,109,61,.30)",
  ring: "rgba(3,109,61,.55)",
};

export const COMPANY = {
  nome: "Ramlis Machine",
  telefone: "+55 11 9 9885-9120",
  whatsapp: "5511998859120",
  email: "contato@ramlismachine.com.br",
  endereco: "R. Tartaruga, 107 - Condomínio Villa Verde, Bragança Paulista/SP",
  horario: "Segunda a quinta, das 07h às 17h; sexta, das 07h às 16h.",
};

export const ALLOWED_EXT_RFQ = /\.(pdf|step|stp|igs|iges|dwg|dxf)$/i;
export const MAX_SIZE_RFQ_MB = 25;

export const ALLOWED_EXT_CV = /\.(pdf)$/i;
export const MAX_SIZE_CV_MB = 10;


export const mapsDeepLink = "https://www.google.com/maps/place/Ramlis+Machine/@-22.9391539,-46.5802287,357m/data=!3m1!1e3!4m6!3m5!1s0x94cec9eb529b4545:0x570ea33100da1ef6!8m2!3d-22.9391539!4d-46.5779756!16s%2Fg%2F11bz_wjzgc?entry=ttu&g_ep=EgoyMDI1MDkxMC4wIKXMDSoASAFQAw%3D%3D";

export const LAT = -22.9391539;
export const LNG = -46.5779756;

